import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useLanguage } from '@/contexts/LanguageContext';
import logo from '@/assets/logo.png';

export default function Landing() {
  const { t, language, setLanguage } = useLanguage();

  const faqItems = [
    { question: t('faq', 'q1'), answer: t('faq', 'a1') },
    { question: t('faq', 'q2'), answer: t('faq', 'a2') },
    { question: t('faq', 'q3'), answer: t('faq', 'a3') },
    { question: t('faq', 'q4'), answer: t('faq', 'a4') },
    { question: t('faq', 'q5'), answer: t('faq', 'a5') },
  ];

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="w-full px-6 py-4 flex items-center justify-between border-b border-border/50">
        <div className="flex items-center gap-3">
          <img src={logo} alt="Scalemage" className="h-8 w-8" />
          <span className="text-xl font-semibold text-foreground">Scalemage</span>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={() => setLanguage(language === 'en' ? 'es' : 'en')}
            className="text-sm text-muted-foreground hover:text-foreground transition-colors px-2 py-1"
          >
            {language === 'en' ? 'ES' : 'EN'}
          </button>
          <Link to="/auth">
            <Button variant="outline" size="sm">{t('landing', 'signIn')}</Button>
          </Link>
        </div>
      </header>

      {/* Hero */}
      <main className="flex-1 flex flex-col items-center px-6 pt-16 pb-12">
        <div className="text-center max-w-3xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight">
            <span className="bg-gradient-to-r from-primary via-emerald-400 to-primary bg-clip-text text-transparent">
              {t('landing', 'heroTitle1')}
            </span>
            <br />
            <span className="text-foreground">{t('landing', 'heroTitle2')}</span>
          </h1>
          
          <p className="mt-6 text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('landing', 'heroDescription')}
            <span className="text-foreground font-medium"> {t('landing', 'heroHighlight')}</span>
          </p>

          <Link to="/auth?mode=signup" className="mt-10 inline-block">
            <Button size="lg" className="text-lg px-8 py-6 bg-primary hover:bg-primary/90 shadow-[0_0_30px_rgba(16,185,129,0.3)] hover:shadow-[0_0_40px_rgba(16,185,129,0.4)] transition-all">
              {t('landing', 'ctaButton')}
            </Button>
          </Link>

          <p className="mt-4 text-sm text-muted-foreground">
            {t('landing', 'noCreditCard')}
          </p>
        </div>

        {/* FAQ Section */}
        <section className="w-full max-w-2xl mt-20">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">
            {t('landing', 'faqTitle')}
          </h2>
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm text-muted-foreground border-t border-border/50">
        © {new Date().getFullYear()} Scalemage. {t('landing', 'allRightsReserved')}
      </footer>
    </div>
  );
}
